/**
 * A preparação do pacote na coluna Situação da lista de casos (E200.F2, GUS-220, ADR-0143 §2): "Preparando ·
 * <etapa>" enquanto o sistema prepara, "Falha na preparação" com a falha do processamento em
 * aberto. O estado vem de `GET /preparacoes`; o card do caso diz o resto.
 */
import { Badge, Spinner } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import type { PreparacaoEmAndamentoData } from '@/lib/preparacoes';

const t = ptBR.preparacaoDoPacote;

export function MarcaDaPreparacao({
  preparacao,
  codigo,
}: {
  preparacao: PreparacaoEmAndamentoData;
  codigo: string;
}): JSX.Element {
  if (preparacao.situacao === 'falhou') {
    return (
      <Badge
        variant="danger"
        className="ml-2 align-middle"
        data-testid={`casos-row-preparacao-falhou-${codigo}`}
      >
        {t.naLista.falhou}
      </Badge>
    );
  }
  const etapa = t.etapaDaPreparacao[preparacao.etapa ?? 'aguardando_vaga'];
  return (
    <Badge
      variant="info"
      className="ml-2 align-middle"
      data-testid={`casos-row-preparando-${codigo}`}
      data-etapa={preparacao.etapa ?? 'aguardando_vaga'}
    >
      <Spinner size="sm" data-testid="casos-row-preparando-spinner" />
      {t.naLista.preparando.replace('{etapa}', etapa)}
    </Badge>
  );
}
